import {React, useState} from 'react';
import Home from '../Home/Home';
import Orders from '../Orders/Orders';
import Products from '../Products/Products';
import './Header.css';


function Header() {

    const [ home, setHome ] = useState("Home");

    return (
        <div>
            <div className='header'>
                <h1 className='text'>Venom</h1>
                <div className='links'>
                    <button className='buttons-home' onClick={() => setHome("Home")}>Home</button>
                    <button className='buttons-products' onClick={() => setHome("Products")}>Products</button>
                    <button className='buttons-order' onClick={() => setHome("Order")}>Order</button>
                </div>
            </div>

            <div>
                {home === "Home" && <Home/>}
                {home === "Products" && <Products />}
                {home === "Order" && <Orders />}
            </div>
        </div>
    )
}

export default Header
 